import { InvalidContractDateData } from '@qv-bid/components/shared/invalid-contract-date-modal/models';

export class InvalidContractDateModalData {
  constructor(
    public contractDateName: string,
    public invalidContractDateData: InvalidContractDateData[]
  ) {}
}
